var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.4151,
    height: 1.88302,
    rx: 0.94151,
    transform: "matrix(0.708076 0.706136 -0.708076 0.706136 1.33331 0)",
    fill: "#676971"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.4151,
    height: 1.88302,
    rx: 0.94151,
    transform: "matrix(0.708076 -0.706136 -0.708076 -0.706136 1.33337 14)",
    fill: "#676971"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownRight);
export default __webpack_public_path__ + "static/media/dropdownRight.7ed5d4810d6e5f4eabd27cbc83eb7683.svg";
export { ForwardRef as ReactComponent };